import React from 'react';

const PlayIcon = () => {
    return (
        <svg
            width='18'
            height='20'
            viewBox='0 0 18 20'
            fill='#000'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1 10V6.44002C1 2.02002 4.13 0.210017 7.96 2.42002L11.05 4.20002L14.14 5.98002C17.97 8.19002 17.97 11.81 14.14 14.02L11.05 15.8L7.96 17.58C4.13 19.79 1 17.98 1 13.56V10Z'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default PlayIcon;
